// Route de smoke test : l'UI est servie et le routeur répond, sans dépendre de platform-api
export const HealthCheckPage = () => (
  <div className="p-6">
    <p data-testid="health-check" className="font-mono text-sm">
      admin-platform ok
    </p>
  </div>
);
